import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from './Checkbox';

export default function SelectDropdown(props) {
  const checked = props.checked ? props.checked : [];

  const [toggled, setToggled] = useState(false);
  const [query, setQuery] = useState('');

  const { t } = useTranslation();

  const needle = query.trim().toLowerCase();

  // Keep every option mounted (so checked values are still submitted with the
  // form) and just hide the ones that don't match the search term.
  const options = props.options.map((item, index) => {
    const matches = needle === '' ||
      String(item.label).toLowerCase().indexOf(needle) > -1;

    return <li key={index} style={matches ? undefined : {display: 'none'}}>
      <Checkbox
        name={props.name}
        label={item.label}
        value={item.value}
        checked={checked.indexOf(item.value) > -1}
        />
      </li>
  });

  const hasMatches = needle === '' || props.options.some(item =>
    String(item.label).toLowerCase().indexOf(needle) > -1);

  function handleToggle(event) {
    event.preventDefault();
    setToggled(!toggled);
  }

  let buttonId = 'toggle-' + props.id,
      panelId = 'toggle-panel-' + props.id;

  return(
    <div className="dropdown">
      <button className="btn btn-outline-primary dropdown-toggle w-100 text-start" type="button" id={buttonId} data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
        <span className="label-t">{props.label ? props.label : 'Valitse'}</span>
        <span className="icon"><svg width="1.4em" height="1.6em" viewBox="0 0 14 16" aria-hidden="true"><path fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M7.007,1.749v12.495l-5.256-5.27 M12.251,8.979L7.016,14.25"/></svg></span>
      </button>
      <ul className="dropdown-menu" aria-labelledby={buttonId}>
        <li className="dropdown-search px-2 pt-1 pb-2">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder={t('search')}
            value={query}
            autoComplete="off"
            onChange={(event) => setQuery(event.target.value)}
            onClick={(event) => event.stopPropagation()}
            />
        </li>
        {options}
        {!hasMatches &&
          <li className="dropdown-no-results px-2 py-1 text-muted">{t('no_records_found')}</li>}
      </ul>
    </div>
  );
}
